var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconEye = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_491_2231)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.75 9.99985C13.75 12.0709 12.0711 13.7498 10 13.7498C7.92893 13.7498 6.25 12.0709 6.25 9.99985C6.25 7.92878 7.92893 6.24985 10 6.24985C12.0711 6.24985 13.75 7.92878 13.75 9.99985ZM12.5 9.99985C12.5 11.3806 11.3807 12.4998 10 12.4998C8.61929 12.4998 7.5 11.3806 7.5 9.99985C7.5 8.61914 8.61929 7.49985 10 7.49985C11.3807 7.49985 12.5 8.61914 12.5 9.99985Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.25 10.0003C5.625 2.49988 14.375 2.49994 18.75 10.0003C14.375 17.4999 5.625 17.4999 1.25 10.0003ZM10 14.375C7.40607 14.375 4.69665 12.9916 2.72073 10.0002C4.69667 7.00848 7.40612 5.625 10 5.625C12.5939 5.625 15.3033 7.0085 17.2793 10.0002C15.3034 12.9916 12.5939 14.375 10 14.375Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_491_2231"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconEye);
export default ForwardRef;